import { Category } from "@mui/icons-material"

const PRICING_CATEGORY = {
  ORIGIN: { label: 'Origin Charges', order: 1 },
  FREIGHT: { label: 'Freight Charges', order: 2 },
  DESTINATION: { label: 'Destination Charges', order: 3 },
   REBATE: { label: 'Rebate', order: 4 },
   PKB: { label: 'Freight Commission', order: 5 },
  OTHERS:{label: 'FREIGHT', order: 6}
};

export const CATEGORY_ORDER = Object.keys(PRICING_CATEGORY);

function groupedByCategory(data) {
  if (!data) return {}

  const map = data
    .filter(e => e.chargeDescription !== 'Volume Discount')
    .reduce((acc, e) => {
      const cat = e.category || 'FREIGHT'
      if (!acc[cat]) acc[cat] = []
      acc[cat].push(e)
      return acc
    }, {})
  const ordered = {}
  CATEGORY_ORDER.forEach(cat => {
    if (map[cat]) ordered[cat] = map[cat]
  })

  return ordered
}



const lclpp = {
  initialLength: 4,
  preList: [
    {
      id: 1,
      category: 'ORIGIN',
      chargeDescription: 'Terminal Handling Fees',
      currency: '',
      perCBM: 0,
      perTon: 0,
      minimum: 0,
      maximum: 0,
      onaccount: "On Your Account",
    },
    {
      id: 2,
      category: 'ORIGIN',
      chargeDescription: 'BL Fees',
      currency: '',
      perCBM: 0,
      perTon: 0,
      minimum: 0,
      maximum: 0,
      onaccount: "On Your Account",
    },
    {
      id: 3,
      category: 'FREIGHT',
      chargeDescription: 'Ocean Freight',
      currency: 'USD',
      perCBM: 0,
      perTon: 0,
      minimum: 0,
      maximum: 0,
      onaccount: "On Your Account",
    },
    {
      id: 4,
      category: 'DESTINATION',
      chargeDescription: 'Destination Charges',
      currency: '',
      perCBM: 0,
      perTon: 0,
      minimum: 0,
      maximum: 0,
      onaccount: "On Your Account",
    },
  ], rebate:[
    {
      id: 1,
      category: 'REBATE',
      chargeDescription: 'Rebate',
      currency: 'USD',
      perCBM: 0,
      perTon: 0,
    },
    
  ], pkb:[
    {
      id: 1,
      category: 'PKB',
      chargeDescription: 'Freight Commission',
      currency: 'USD',
      perCBM: 0,
      perTon: 0,
    },
  ]
};

const lcldp = {
    initialLength: 6,
    preList: [{
            id: 1,
             category: 'ORIGIN',
            chargeDescription: 'Pick-up Charges',
            currency: 'INR',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            onaccount: "On Your Account",
            // disabled: ['perCBM','perTon','maximum', 'minimum']
        },
        {
            id: 2,
             category: 'ORIGIN',
            chargeDescription: 'Origin Customs Clearance',
            currency: 'INR',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            onaccount: "On Your Account",
            disabled: ['perCBM','perTon','maximum', 'minimum']
        },
        {
            id: 3,
             category: 'FREIGHT',
            chargeDescription: 'Ocean Freight',
            currency: 'USD',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            // disabled: ['perShipment'],
            onaccount: "On Your Account",
        },
        {
            id: 4,
             category: 'DESTINATION',
            chargeDescription: 'Destination Charges',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
            onaccount: "On Your Account",
        },{
            id: 5,
            chargeDescription: 'Terminal Handling Fees',
             category: 'ORIGIN',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
            onaccount: "On Your Account",
        },{
            id: 6,
             category: 'ORIGIN',
            chargeDescription: 'BL Fees',
           perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
            onaccount: "On Your Account",
        }
   
    ], rebate:[
    {
      id: 1,
      category: 'REBATE',
      chargeDescription: 'Rebate',
      currency: 'USD',
      perCBM: 0,
      perTon: 0,
    },
    
  ], pkb:[
    {
      id: 1,
      category: 'PKB',
      chargeDescription: 'Freight Commission',
      currency: 'USD',
      perCBM: 0,
      perTon: 0,
    },
  ]
}
const lclpd = {
    initialLength: 6,
    preList: [
      {
            id: 3,
            chargeDescription: 'Terminal Handling Fees',
             category: 'ORIGIN',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
            onaccount: "On Your Account",
        },{
            id: 4,
            chargeDescription: 'BL Fees',
             category: 'ORIGIN',
           perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
            onaccount: "On Your Account",
        },
        {
            id: 1,
             category: 'FREIGHT',
            chargeDescription: 'Ocean Freight',
            currency: 'USD',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            // disabled: ['perShipment'],
            onaccount: "On Your Account",
        },
        {
            id: 2,
            chargeDescription: 'Destination Charges',
             category: 'DESTINATION',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
            onaccount: "On Your Account",
        },
        {
            id: 5,
               category: 'DESTINATION',
            chargeDescription: 'Destination Customs Clearance',
            currency: '',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            disabled: ['perCBM','perTon','maximum', 'minimum'],
            onaccount: "On Your Account",
        },
        {
            id: 6,
               category: 'DESTINATION',
            chargeDescription: 'Delivery Charges',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
            onaccount: "On Your Account",
            // disabled: ['perCBM','perTon','maximum', 'minimum']
        },
    ], rebate:[
    {
      id: 1,
      category: 'REBATE',
      chargeDescription: 'Rebate',
      currency: 'USD',
      perCBM: 0,
      perTon: 0,
    },
    
  ], pkb:[
    {
      id: 1,
      category: 'PKB',
      chargeDescription: 'Freight Commission',
      currency: 'USD',
      perCBM: 0,
      perTon: 0,
    },
  ]
}
const lcldd = {
    initialLength: 8,
    preList: [
        {
            id: 1,
             category: 'ORIGIN',
            chargeDescription: 'Pick-up Charges',
            currency: 'INR',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            onaccount: "On Your Account",
            // disabled: ['perCBM','perTon','maximum', 'minimum']
        },
        {
            id: 2,
             category: 'ORIGIN',
            chargeDescription: 'Origin Customs Clearance',
            currency: 'INR',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            onaccount: "On Your Account",
            disabled: ['perCBM','perTon','maximum', 'minimum']
        },
        {
            id: 3,
             category: 'FREIGHT',
            chargeDescription: 'Ocean Freight',
            currency: 'USD',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            // disabled: ['perShipment'],
            onaccount: "On Your Account",
        },
        {
            id: 4,
               category: 'DESTINATION',
            chargeDescription: 'Destination Charges',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
            onaccount: "On Your Account",
        },{
            id: 5,
            chargeDescription: 'Terminal Handling Fees',
             category: 'ORIGIN',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
            onaccount: "On Your Account",
        },{
            id: 6,
            chargeDescription: 'BL Fees',
             category: 'ORIGIN',
           perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
            onaccount: "On Your Account",
        },
        {
            id: 7,
            category: 'DESTINATION',
            chargeDescription: 'Destination Customs Clearance',
            currency: '',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            disabled: ['perCBM','perTon','maximum', 'minimum'],
            onaccount: "On Your Account",
        },
        {
            id: 8,
            category: 'DESTINATION',
            chargeDescription: 'Delivery Charges',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
            onaccount: "On Your Account",
            // disabled: ['perCBM','perTon','maximum', 'minimum']
        },
   
    ], rebate:[
    {
      id: 1,
      category: 'REBATE',
      chargeDescription: 'Rebate',
      currency: 'USD',
      perCBM: 0,
      perTon: 0,
    },
    
  ], pkb:[
    {
      id: 1,
      category: 'PKB',
      chargeDescription: 'Freight Commission',
      currency: 'USD',
      perCBM: 0,
      perTon: 0,
    },
  ]
}

export {
    lclpp,lcldp,lclpd,lcldd, PRICING_CATEGORY, groupedByCategory
}